const TrustSection = () => {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Indépendance éditoriale',
      description:
        'Analyses libres et objectives, sans influence politique ou économique. Notre seul engagement : documenter la réalité des mouvements citoyens.',
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Rigueur documentaire',
      description:
        'Vérification des sources, contextualisation historique et analyse approfondie. Chaque article s\'appuie sur des faits vérifiables et des témoignages directs.',
    },
    {
      icon: 'ri-community-line',
      title: 'Engagement citoyen',
      description:
        'Au service de la démocratie et du débat public. Nous donnons la parole aux acteurs de terrain et éclairons les enjeux sociétaux contemporains.',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-serif font-bold text-[#1a1a1a] mb-4">
            Nos valeurs
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Giletau s'engage à documenter et analyser les mouvements citoyens avec rigueur, indépendance et transparence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all border border-gray-100"
            >
              <div className="bg-[#1a1a1a] text-white w-16 h-16 flex items-center justify-center rounded-xl mb-6">
                <i className={`${value.icon} text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a1a1a] mb-3">
                {value.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
